import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-title" }, " Visualizza log degli ultimi eventi ", -1)
const _hoisted_4 = { class: "my-card mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold my-card--header" }, " Actions ", -1)
const _hoisted_6 = { class: "my-buttons my-card--body" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Aggiorna lista ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Precedente ")
const _hoisted_9 = { class: "mx-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Successiva ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-sync",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshData(0)))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-arrow-left",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshData(_ctx.page - 1)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, " Pagina " + _toDisplayString(_ctx.page + 1), 1),
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-arrow-right",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshData(_ctx.page + 1)))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_Table, {
        data: _ctx.listEvents,
        config: _ctx.configTable
      }, null, 8, ["data", "config"])
    ])
  ]))
}